module.exports = __webpack_public_path__ + "static/img/logo-b.900fcd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-b.png
// module id = YJNR
// module chunks = 13